/* 
  
  
 */
import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';
import UrlSerializable from './UrlSerializable';
import { extend, getPath, hasPath, parseBIURLFragment, serializeUrlMainPart } from './utils';
import { BaseService } from '../BaseService';
import nextTick from 'next-tick';
import { AppConfig } from '../AppConfig';
const DEFAULT_URL_STRUCTURE = {
    metrics: [String],
    preset: Number,
    locations: [Number],
    period: { start: String, end: String, type: Number },
    geo: { lat: Number, lng: Number, zoom: Number },
    autoscale: Boolean,
    loc: Boolean,
    mf: { e: Boolean, ls: [Number], m: String }, //                                        
    dboard: String, //          
    dash: String,
    slide: String,
    ao: String,
};
let locationHash = '#';
//                                                                      
//                                                                                    
//                                      
export let onUrlStateNavigate = null;
export function setOnUrlStateNavigate(fn) {
    onUrlStateNavigate = fn;
}
//                                                                                             
export function setLocationHash(hash) {
    locationHash = hash;
}
//                                                                     
//                                                                                  
let nativeRouterMode = false;
export function setNativeRouterMode(value) {
    nativeRouterMode = value;
}
function getCurrentHash() {
    return (!nativeRouterMode && window.location?.hash) || locationHash;
}
export class UrlState extends BaseService {
    _entryPoint = null;
    _urlStructure;
    _urlSerializable;
    constructor() {
        super();
        this._model = this._initModel();
        if (window.addEventListener) {
            window.addEventListener('hashchange', this._changeHangler, false);
        }
        AppConfig.getInstance().subscribeUpdates(this._changeHangler);
    }
    _initModel() {
        if (!this._urlStructure)
            this._urlStructure = DEFAULT_URL_STRUCTURE;
        if (!this._urlSerializable)
            this._urlSerializable = new UrlSerializable(DEFAULT_URL_STRUCTURE);
        const url = this.deserializeUrl(getCurrentHash());
        return url;
    }
    setEntryPoint(entryPoint) {
        this._entryPoint = entryPoint;
        this._setModel(this._initModel());
    }
    setUrlStructure(urlStructure) {
        this._urlStructure = urlStructure;
        this._urlSerializable = new UrlSerializable(urlStructure);
        this._setModel(this._initModel());
    }
    _smartUpdate(newModel, prevModel) {
        const keys = uniq(Object.keys(newModel).concat(Object.keys(prevModel)));
        const result = { path: [] };
        for (const key of keys) {
            const hasNewValue = Object.prototype.hasOwnProperty.call(newModel, key);
            const hasPrevValue = Object.prototype.hasOwnProperty.call(prevModel, key);
            const valueChanged = hasNewValue !== hasPrevValue || !isEqual(newModel[key], prevModel[key]);
            if (valueChanged) {
                if (hasNewValue)
                    result[key] = newModel[key];
            }
            else {
                result[key] = prevModel[key];
            }
        }
        return result;
    }
    _isModelChanged(nextModel, currentModel) {
        return !isEqual(nextModel, currentModel);
    }
    buildUrl(additionalState) {
        const url = this.getModel();
        const newState = extend(url, additionalState, this._urlStructure);
        newState.segment = 'segment' in additionalState ? additionalState.segment : url.segment;
        newState.segmentId = 'segmentId' in additionalState ? additionalState.segmentId : url.segmentId;
        newState.route = 'route' in additionalState ? additionalState.route : url.route;
        newState.routeId = 'routeId' in additionalState ? additionalState.routeId : url.routeId;
        let path = additionalState.path || null;
        if (Array.isArray(path)) {
            //                                                                      
            newState.segment = path.length >= 1 ? path[0] : null;
            newState.segmentId = path.length >= 2 ? path[1] : null;
            newState.route = path.length >= 3 ? path[2] : null;
            newState.routeId = path.length >= 4 ? path[3] : null;
        }
        else if (typeof additionalState.path === 'string') {
            //                 
        }
        else {
            newState.path = [];
            if (newState.segment !== null)
                newState.path[0] = newState.segment;
            if (newState.segmentId !== null)
                newState.path[1] = newState.segmentId;
            if (newState.route !== null)
                newState.path[2] = typeof newState.route === 'string' && newState.route[0] === '#' ? newState.route.slice(1) : newState.route;
            if (newState.routeId !== null)
                newState.path[3] = newState.routeId;
        }
        const sUrl = this._serializeUrl(newState);
        return sUrl;
    }
    _serializeUrl(hash) {
        let mainPart = serializeUrlMainPart(hash);
        const query = { ...hash };
        delete query.path;
        delete query.segment;
        delete query.segmentId;
        delete query.route;
        delete query.routeId;
        delete query.modals;
        //                               
        Object.keys(query)
            .filter(key => key.startsWith('_'))
            .forEach(key => delete query[key]);
        let searchStr = this._urlSerializable.serializeSearch(query);
        if (!mainPart && searchStr) {
            mainPart = '#/';
        }
        if (searchStr) {
            searchStr = '?' + searchStr;
        }
        return mainPart + searchStr;
    }
    getModel() {
        return this._model;
    }
    _setModel(model) {
        super._setModel(model);
    }
    /* 
                                                                           
      
                                                                           
                                                                          
                                                                                 
     */
    //                                                                          
    //                                                 
    syncFromRouterLocation(fragment) {
        const urlWithoutEntryPoint = this._deserializeUrl(fragment);
        const sourceHash = this._serializeUrl(urlWithoutEntryPoint);
        const url = this._applyEntryPoint(this._cloneUrl(urlWithoutEntryPoint));
        const entryPointApplied = !isEqual(url, urlWithoutEntryPoint);
        const underscoredHash = {};
        Object.keys(this._model)
            .filter(key => key.startsWith('_'))
            .forEach(key => (underscoredHash[key] = this._model[key]));
        const newModel = {
            //                
            ...url,
            modals: this._model.modals,
            ...underscoredHash,
            //                                                                                                
            //                                                                                         
            //             
        };
        this._setModel(newModel);
        if (!entryPointApplied)
            return null;
        //                                                                    
        //                                      
        const targetHash = this.buildUrl({});
        return targetHash !== sourceHash ? (targetHash || '#') : null;
    }
    _changeHangler = () => {
        this.syncFromRouterLocation(getCurrentHash());
    };
    //                                                                          
    //                                                 
    navigate(additionalQuery, option) {
        //
        //                                           
        //                                                        
        //
        let urlHash = this.buildUrl(additionalQuery);
        if (urlHash === (getCurrentHash())) {
            //                        
            return;
        }
        if (!urlHash) {
            urlHash = '#';
        }
        const w = typeof window !== 'undefined' ? window : undefined;
        const h = w?.history;
        if (!nativeRouterMode && h && typeof h.pushState === 'function' && typeof w.addEventListener === 'function') {
            if (option && option.replace)
                h.replaceState(undefined, undefined, urlHash);
            else
                h.pushState(undefined, undefined, urlHash);
            if (typeof PopStateEvent === "function" && typeof w.dispatchEvent === "function")
                w.dispatchEvent(new PopStateEvent("popstate")); //                  
        }
        else {
            //                                     
            locationHash = urlHash;
            onUrlStateNavigate?.(urlHash);
            this._changeHangler();
        }
        //                   
        //              
        nextTick(this._changeHangler);
    }
    updateModel(partialModel, isReplace = false) {
        //              
        if ('locations' in partialModel) {
            if (partialModel.locations === null || Array.isArray(partialModel.locations)) {
                //   
            }
            else {
                delete partialModel.locations;
            }
        }
        let newModel = {
            ...this._model,
            ...partialModel,
        };
        if (newModel.f && Object.keys(newModel.f).length === 0)
            delete newModel.f;
        if (hasPath(partialModel)) {
            let path = getPath(partialModel);
            let modelPath = getPath(this._model);
            for (let i = 0; i < path.length; i++) {
                if (path[i] === undefined || path[i] === true) {
                    //                             
                    path[i] = modelPath[i];
                }
            }
            newModel = {
                ...newModel,
                path,
                segment: path[0],
                segmentId: path[1],
                route: path[2],
                routeId: path[3],
            };
        }
        const urlChanged = this._serializeUrl(newModel) !== this._serializeUrl(this._model);
        if (urlChanged) {
            this.setModel(newModel, isReplace);
        }
        else {
            this._setModel(newModel);
        }
    }
    removeInternalField(key) {
        const newModel = { ...this._model };
        delete newModel[key];
        this._setModel(newModel);
    }
    //                                                                          
    //                                                 
    setModel(model, replaceUrl = false) {
        if (!('path' in model)) {
            //           
            model = { ...model, path: getPath(model) };
        }
        let urlHash = this.buildUrl(model);
        if (urlHash !== (getCurrentHash())) {
            if (!urlHash) {
                urlHash = '#';
            }
            const w = typeof window !== 'undefined' ? window : undefined;
            const h = w?.history;
            if (!nativeRouterMode && h && typeof h.pushState === "function") {
                if (replaceUrl)
                    h.replaceState(undefined, undefined, urlHash);
                else
                    h.pushState(undefined, undefined, urlHash);
                if (typeof PopStateEvent === "function" && typeof w.dispatchEvent === "function")
                    w.dispatchEvent(new PopStateEvent("popstate")); //                  
            }
            else {
                //                                     
                locationHash = urlHash;
                onUrlStateNavigate?.(urlHash);
            }
        }
        this._setModel(model);
    }
    _dispose() {
        throw new Error('Cannot dispose UrlState');
        //                  
    }
    //
    //                                                                         
    //
    deserializeUrl(fragment) {
        return this._applyEntryPoint(this._deserializeUrl(fragment));
    }
    _deserializeUrl(fragment) {
        const parsedFragment = parseBIURLFragment(fragment);
        const result = this._deserializeSearch(parsedFragment.search);
        result.segment = parsedFragment.segment;
        result.segmentId = parsedFragment.segmentId;
        result.route = parsedFragment.route !== null ? '#' + parsedFragment.route : null;
        result.routeId = parsedFragment.routeId;
        result.path = parsedFragment.path;
        return result;
    }
    _cloneUrl(url) {
        const clone = { ...url, path: [...url.path] };
        for (const key of Object.keys(clone)) {
            if (Array.isArray(clone[key]))
                clone[key] = [...clone[key]];
        }
        return clone;
    }
    _applyEntryPoint(result) {
        const entryPoint = AppConfig.getModel().entryPoint || this._entryPoint; //                            
        if (!entryPoint)
            return result;
        //                   
        //                                                                          
        for (const key of Object.keys(entryPoint)) {
            if (key === 'path' && Array.isArray(entryPoint.path)) {
                entryPoint.path.forEach((pathEntry, i) => (result.path[i] = result.path[i] || pathEntry));
                result.segment = result.path[0] ?? null;
                result.segmentId = result.path[1] ?? null;
                result.route = result.path[2] ?? null;
                result.routeId = result.path[3] ?? null;
            }
            else if (key === 'segment' && result.segment === null) {
                result.path[0] = result.segment = entryPoint.segment;
            }
            else if (key === 'segmentId' && result.segmentId === null) {
                result.path[1] = result.segmentId = entryPoint.segmentId;
            }
            else if (key === 'route' && result.route === null) {
                result.path[2] = result.route = entryPoint.route;
            }
            else if (key === 'routeId' && result.routeId === null) {
                result.path[3] = result.routeId = entryPoint.routeId;
            }
            else if (result[key] === null || result[key] === undefined) {
                //                
                result[key] = entryPoint[key];
            }
            else if (Array.isArray(result[key]) && result[key].length === 0) {
                //                       
                result[key] = entryPoint[key];
            }
        }
        return result;
    }
    _deserializeSearch(search) {
        return this._urlSerializable.deserializeSearch(search);
    }
    static _instance = null;
    static getInstance() {
        if (!this._instance) {
            this._instance = new UrlState();
            if (typeof window !== 'undefined')
                window.__urlState = this._instance; //      
        }
        return this._instance;
    }
    static getModel() {
        return this.getInstance().getModel();
    }
    static subscribe(event, listener) {
        return this.getInstance().subscribe(event, listener);
    }
    static subscribeUpdatesAndNotify(listener) {
        return this.getInstance().subscribeUpdatesAndNotify(listener);
    }
    static subscribeAndNotify(event, listener) {
        return this.getInstance().subscribeAndNotify(event, listener);
    }
    static subscribeUpdates(listener) {
        return this.getInstance().subscribeUpdates(listener);
    }
    static unsubscribe(listener) {
        return this.getInstance().unsubscribe(listener);
    }
    static navigate(additionalQuery, option) {
        this.getInstance().navigate(additionalQuery, option);
    }
}
export const urlState = UrlState.getInstance();
